import { render, staticRenderFns } from "./ChannelGroupSidebar.vue?vue&type=template&id=2a027d7a&"
import script from "./ChannelGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./ChannelGroupSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChannelGroupSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports